import { debounce } from "../utils/delays";
import { lenis } from "./animations";

export const ajaxMainFilter = (filters, postType) => {
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  if(filters.length < 1) return;

  const urlUpdate = (mainCat, newValue) => {
    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search);

    if(params.has(mainCat)) {
      let existingValues = params.get(mainCat).split(',');
      if (existingValues.includes(newValue)) {
        existingValues = existingValues.filter(value => value !== newValue);
      } else {
        existingValues.push(newValue);
      }

      if (existingValues.length > 0) {
        params.set(mainCat, existingValues.filter(value => value !== '').join(','));
      } else {
        params.delete(mainCat);
      }
    } else {
      params.set(mainCat, newValue);
    }

    url.search = params.toString().replace(/%2C/g, ',');
    window.history.pushState({}, '', url);
  }

  filters.forEach(project => {
    const navTermsContainer = project.querySelector('.sk-acc-filter__nav-terms');
    if (!navTermsContainer) return;

    const getNavBtn = (e) => {
      const btn = e.target.closest('.sk-acc-filter__nav-btn');
      return btn && navTermsContainer.contains(btn) ? btn : null;
    };

    const closeActiveBtn = (except = null) => {
      const active = navTermsContainer.querySelector('.sk-acc-filter__nav-btn.open');
      if (active && active !== except) active.classList.remove('open');
    };

    const closeAllNavBtns = () => {
      navTermsContainer.querySelectorAll('.sk-acc-filter__nav-btn.open').forEach(btn => {
        btn.classList.remove('open');
        btn.setAttribute('aria-expanded', 'false');
      });
    };

    if (!isTouchDevice) {
      navTermsContainer.addEventListener('mouseover', (e) => {
        const btn = getNavBtn(e);
        if (!btn) return;
        closeActiveBtn(btn);
        btn.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
      });

      navTermsContainer.addEventListener('mouseleave', closeAllNavBtns);

      navTermsContainer.addEventListener('keydown', (e) => {
        const btn = getNavBtn(e);
        if (!btn) return;

        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (!btn) return;
          const isOpen = btn.classList.contains('open');
          closeActiveBtn(btn);
          btn.classList.toggle('open', !isOpen);
          btn.setAttribute('aria-expanded', String(!isOpen));
        }

        if (e.key === 'Escape') {
          closeAllNavBtns();
          btn.blur();
        }
      });
    } else {
      document.addEventListener('click', (e) => (!navTermsContainer.contains(e.target)) && closeActiveBtn());
    }

    project.addEventListener('click', (e) => {
      const btn = e.target.closest('.sk-acc-filter__btn');
      btn && btn.closest('.sk-acc-filter__item').classList.toggle('open');

      if (e.target.classList.contains('sk-acc-filter__nav-input')) {
        const activeFilter = e.target.closest('.sk-acc-filter__nav-checkbox');
        const mainCat = activeFilter.getAttribute('data-term');
        const newValue = e.target.value;

        mainCat && newValue && urlUpdate(mainCat, newValue);
      }

      if (!isTouchDevice) return;

      const tax = getNavBtn(e);
      if (!tax) return;

      closeActiveBtn(tax);
      tax.classList.toggle('open');
    });

    const filterForm = project.querySelector('[data-filter-form]');
    if (!filterForm) return;

    const filterFormItemsContainer = project.querySelector('#items-wrap');
    const searchField = filterForm.querySelector('.sk-acc-filter__search');
    const itemsTotal = project.querySelector('.sk-acc-filter__total');
    const nonce = themeVars.nonce;
    const preloadOffset = 300;

    let isLoadingFlag = false;
    let currentPage = 1;
    let totalPages = 1;
    let lastSearchValue = '';

    function animateNewItems(container) {
      const items = container.querySelectorAll('.sk-acc-filter__item:not(.animate)');
      items.forEach((item, index) => setTimeout(() => item.classList.add('animate'), index * 100));
    }

    const checkInfiniteScroll = () => {
      if (isLoadingFlag || currentPage >= totalPages) return;

      const rect = filterFormItemsContainer.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

      if (rect.bottom - preloadOffset <= viewportHeight) frontEndAjaxCall('load', currentPage + 1);
    };

    (window.lenis) ? lenis.on('scroll', checkInfiniteScroll) : window.addEventListener('scroll', checkInfiniteScroll);

    function onAjaxComplete() {
      if (window.lenis) lenis.resize();

      const containerHeight = filterFormItemsContainer.scrollHeight;
      const viewportHeight = filterFormItemsContainer.clientHeight;

      if (containerHeight > viewportHeight) return;
    }

    function getActiveFilters(filterForm) {
      const filterItems = filterForm.querySelectorAll('.sk-acc-filter__nav-checkbox');
      let queryParts = [];

      filterItems.forEach(item => {
        const taxName = item.dataset.term;
        if (!taxName) return;

        const values = [...item.querySelectorAll(`.sk-acc-filter__nav-input:checked`)].map(input => input.value);

        if (values.length > 0) queryParts.push(`${taxName}=${encodeURIComponent(values.join(','))}`);
      });

      return queryParts.length > 0 ? `&${queryParts.join('&')}` : '';
    }

    function frontEndAjaxCall (type, loadMorePage) {
      if (isLoadingFlag) return;
      isLoadingFlag = true;

      const pageToLoad = loadMorePage ?? 1;
      const filtersQuery = getActiveFilters(filterForm);
      const filterStatus = filterForm.dataset.status ? `&status=${filterForm.dataset.status}` : '';
      const filterButtonType = filterForm.dataset.page ? `&button_type=${filterForm.dataset.page}` : '';
      const filterMember = filterForm.dataset.member ? `&member=${filterForm.dataset.member}` : '';
      const filterSearch = searchField ? `&s=${searchField.value}` : '';
      const previewUserId = Number(new URLSearchParams(window.location.search).get('preview_user') || 0);
      const previewUser = previewUserId ? `&preview_user=${previewUserId}` : '';

      fetch(themeVars.ajax_url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `action=ajax_filter_fn&nonce=${nonce}&post_type=${postType}&page=${pageToLoad}${filtersQuery}${filterStatus}${filterButtonType}${filterMember}${filterSearch}${previewUser}`,
      })
        .then(async response => {
          if (!response.ok) {
            if (response.status === 503) {
              return new Promise((resolve) => setTimeout(resolve, 3000)).then(frontEndAjaxCall);
            } else {
              throw new Error('Network response was not ok');
            }
          }

          return response.json();
        })
        .then(data => {
          totalPages = data.total_pages || 1;

          if (type === 'change') {
            currentPage = 1;
            filterFormItemsContainer.innerHTML = data.response_compile;
            animateNewItems(filterFormItemsContainer);
          } else if (type === 'load') {
            currentPage = pageToLoad;
            filterFormItemsContainer.insertAdjacentHTML('beforeend', data.response_compile);
            animateNewItems(filterFormItemsContainer);
          }

          itemsTotal.innerHTML = data.total_items;
          onAjaxComplete();
        })
        .catch((error) => console.log(error))
        .finally(() => {
          isLoadingFlag = false;
        });
    }

    frontEndAjaxCall('change', 1);

    filterForm.addEventListener('change', (e) => {
      if(!e.target.classList.contains('sk-acc-filter__search')) {
        frontEndAjaxCall('change', 1);
      }
    });

    if (searchField) {
      searchField.addEventListener('input', debounce(() => {
        const value = searchField.value.trim();

        if (value === lastSearchValue) return;
        lastSearchValue = value;

        if (value.length >= 3 || value.length === 0) frontEndAjaxCall('change', 1);
      }, 300));
    }
  });
}